import { useMemo } from 'react';
import { useBoolState } from '@/hooks/state/useBoolState';
export const useFoldableListChat = (options) => {
    var _a, _b;
    const { items = [], user } = options;
    // メッセージ一覧折りたたみ状態
    const { boolState: isShowAll, changeToggle: toggleIsShowAll } = useBoolState();
    /**
     * 未読のメッセージがあるかどうか判定
     */
    const hasUnreadMessage = useMemo(() => items.some(({ message }) => message.unread), [items]);
    /**
     * メッセージのグルーピング
     * @return {{ user: {object}, messages: {object}[] }[]}
     */
    const customItems = useMemo(() => {
        const result = [];
        items.forEach((item) => {
            var _a, _b;
            const prevItem = result[result.length - 1];
            const prevClientId = (_a = prevItem === null || prevItem === void 0 ? void 0 : prevItem.user) === null || _a === void 0 ? void 0 : _a.clientId;
            const prevProfessionalId = (_b = prevItem === null || prevItem === void 0 ? void 0 : prevItem.user) === null || _b === void 0 ? void 0 : _b.professionalId;
            const currentClientId = item.user.clientId;
            const currentProfessionalId = item.user.professionalId;
            // 前メッセージとユーザー比較
            if (!prevItem ||
                !(prevClientId === currentClientId &&
                    prevProfessionalId === currentProfessionalId)) {
                // 異なる場合 新規 object push
                result.push({
                    messages: [item.message],
                    user: item.user,
                });
            }
            else {
                // 同じ場合 前データの messages に message push
                prevItem.messages.push(item.message);
            }
        });
        return result;
    }, [items]);
    // 初期状態
    const isInitial = customItems.length === 0;
    // 相手からのメッセージが1度もない場合
    const isFirst = customItems.length === 1 &&
        customItems[0].user.clientId === user.clientId &&
        customItems[0].user.professionalId === user.professionalId;
    // 最後の送信が自分か
    const lastMessage = customItems[customItems.length - 1];
    const isSelfLastMessage = ((_a = lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.user) === null || _a === void 0 ? void 0 : _a.clientId) === user.clientId &&
        ((_b = lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.user) === null || _b === void 0 ? void 0 : _b.professionalId) === user.professionalId;
    // メッセージの一覧の折りたたみが可能か
    const foldableList = customItems.length >= 3;
    return {
        customItems,
        foldableList,
        hasUnreadMessage,
        isFirst,
        isInitial,
        isSelfLastMessage,
        isShowAll,
        toggleIsShowAll,
    };
};
